/**
 * SPDX-FileCopyrightText: (c) 2026 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import React from 'react';

const ClayTableBody = React.forwardRef<
	HTMLTableSectionElement,
	React.TableHTMLAttributes<HTMLTableSectionElement>
>(({children, ...otherProps}, ref) => {
	return (
		<tbody {...otherProps} ref={ref}>
			{children}
		</tbody>
	);
});

ClayTableBody.displayName = 'ClayTableBody';

export default ClayTableBody;
